function Result(code = 0, message = null, data = null) {
  if (!(this instanceof Result)) {
    return new Result(code, message, data);
  }

  Object.defineProperties(this, {
    code: {
      enumerable: true,
      value: code
    },
    message: {
      enumerable: true,
      value: message
    },
    data: {
      enumerable: true,
      value: data
    }
  });
}

export default Result;
